import styled from 'styled-components';
import { Tag } from 'antd';

export const PopoverContainer = styled.div`
  width: 390px;
  max-width: 92vw;
  background: #ffffff;
  display: flex;
  flex-direction: column;
`;

export const PopoverHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
`;

export const HeaderTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const HeaderTitle = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
`;

export const CountBadge = styled.span`
  font-size: 11px;
  font-weight: 600;
  font-family: monospace;
  color: #2563eb;
  background: #dbeafe;
  padding: 1px 7px;
  border-radius: 999px;
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ActionLinkButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11.5px;
  font-weight: 500;
  color: #2563eb;
  background: transparent;
  border: none;
  padding: 2px 6px;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    background: #eff6ff;
    color: #1d4ed8;
  }
`;

export const SubHeaderHint = styled.div`
  font-size: 11px;
  color: #64748b;
  padding: 6px 14px;
  background: #f1f5f9;
  border-bottom: 1px solid #e2e8f0;
`;

export const WidgetList = styled.div`
  max-height: min(250px, 34vh);
  overflow-y: auto;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const WidgetRowItem = styled.div<{ $visible: boolean; $isDragging: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 10px;
  border-radius: 8px;
  background: ${(props) =>
    props.$isDragging ? '#eff6ff' : props.$visible ? '#ffffff' : '#f8fafc'};
  border: 1px solid
    ${(props) =>
      props.$isDragging ? '#93c5fd' : props.$visible ? '#e2e8f0' : '#f1f5f9'};
  box-shadow: ${(props) =>
    props.$isDragging ? '0 4px 12px rgba(37, 99, 235, 0.15)' : 'none'};
  transition: background 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
  }
`;

export const DragAndOrderControls = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  flex-shrink: 0;
`;

export const DragHandle = styled.div<{ $isDragging?: boolean }>`
  cursor: ${(props) => (props.$isDragging ? 'grabbing' : 'grab')};
  touch-action: none;
  -webkit-user-select: none;
  user-select: none;
  color: #94a3b8;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 2px;
  font-size: 14px;

  &:hover {
    color: #475569;
  }

  &:active {
    cursor: grabbing;
  }
`;

export const OrderArrowGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`;

export const OrderArrowBtn = styled.button`
  border: none;
  background: transparent;
  color: #64748b;
  font-size: 9px;
  line-height: 1;
  padding: 2px 3px;
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    background: #e2e8f0;
    color: #1e293b;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export const TypeIconBadge = styled.div<{ $color: string }>`
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: ${(props) => `${props.$color}14`};
  border: 1px solid ${(props) => `${props.$color}30`};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const WidgetInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const WidgetTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
`;

export const WidgetTitle = styled.span<{ $visible: boolean }>`
  font-size: 12.5px;
  font-weight: 600;
  color: ${(props) => (props.$visible ? '#1e293b' : '#94a3b8')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TypeLabelTag = styled(Tag)`
  margin: 0 !important;
  font-size: 10px !important;
  line-height: 15px !important;
  padding: 0 5px !important;
  border-radius: 4px !important;
  flex-shrink: 0;
`;

export const WidgetDescription = styled.div`
  font-size: 11px;
  color: #64748b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SwitchWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
`;
